import { create } from 'zustand';
import { type OnboardingUIAssignmentDecision, resolveOnboardingUIAssignment } from '@/experiments/onboardingUI';

/**
 * 客户端 AB 实验特性开关 store。
 *
 * 客户端实验分组按需拉取并写入，业务侧通过同步 getter 或 hook 读取。
 */
interface ExperimentState {
  onboardingUIDecision: OnboardingUIAssignmentDecision;
  setOnboardingUIDecision: (decision: OnboardingUIAssignmentDecision) => void;
}

export const useExperimentStore = create<ExperimentState>(set => ({
  onboardingUIDecision: resolveOnboardingUIAssignment(null),
  setOnboardingUIDecision: decision => set({ onboardingUIDecision: decision }),
}));

export function useOnboardingUIExperience() {
  return useExperimentStore(state => state.onboardingUIDecision.experience);
}
